import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineSuppAndOfflineOfficeProperties, OfflineSupplierProperties } from '../Models/OfflineSupplierProperties';
import { OfflinesuppliersService } from '../Services/offlinesuppliers.service';

@Component({
  selector: 'app-offline-supplier-list',
  templateUrl: './offline-supplier-list.component.html',
  styleUrls: ['./offline-supplier-list.component.css']
})
export class OfflineSupplierListComponent implements OnInit {
  offlineSuppliersDetails: OfflineSupplierProperties[] = [];
 
  isOpen: boolean = false;
  constructor(private offlineSupplierservice: OfflinesuppliersService, private router: Router) { }

  ngOnInit() {
    this.getSuppliers();
  }
  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }
  createSupplier() {
    localStorage.setItem("TypeCheck", "Create");
    this.router.navigateByUrl("/offlineSupplier");
  }

  updateSupplier(offlineSupplierId) {
    localStorage.setItem("OffSupplierId", offlineSupplierId);
    localStorage.setItem("TypeCheck", "Update");
    this.router.navigateByUrl("/offlineSupplier");
  }

  getSuppliers() {
    this.offlineSupplierservice.getOfflineSupplier().subscribe((data) => {
      this.offlineSuppliersDetails = data;

    });
  }

  changeStatus(obj: OfflineSupplierProperties) {

    this.offlineSupplierservice.UpdateStatus(obj.offlineSupplierId, obj.isActive).subscribe((data) => {


    });

  }
}
